import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { TipoSeguimientoService } from '../../../services/TipoSeguimientoService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'tipo_seguimiento_guia',
    label: 'Nombre del Seguimiento',
    type: 'text',
    col: 12,
    placeholder: 'Ej. EN TRANSITO A SUCURSAL',
    validators: [
      Validators.required("El nombre del seguimiento es obligatorio")
    ],
  },
];

export const TipoSeguimientoForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await TipoSeguimientoService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await TipoSeguimientoService.guardar(values);
  };

  return (
    <CatalogForm
      title="Tipo de Seguimiento"
      subtitle="Estados y etapas para el seguimiento de guías"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/TiposSeguimientos"
    />
  );
};

export default TipoSeguimientoForm;
